export const boliBookingExportColumns = [
	{ label: 'Sr No', key: 'index' },
	{
		label: 'Community',
		render: b => b?.hub?.name || '',
	},
	{
		label: 'Sanstha',
		render: b => b?.sansthaId?.name || '',
	},
	{
		label: 'User Name',
		render: b => (b?.userId ? `${b.userId.firstName || ''} ${b.userId.lastName || ''}`.trim() : ''),
	},
	{
		label: 'User Mobile',
		render: b => b?.userId?.mobile || '',
	},
	{
		label: 'Event',
		render: b => b?.event?.title || '',
	},
	{
		label: 'Event Category',
		render: b => b?.event?.category || '',
	},
	{
		label: 'Boli Item',
		render: b => b?.boli_item || '',
	},
	{
		label: 'Payment Type',
		render: b => (b?.isOffline ? 'Offline' : 'Online'),
	},
	{
		label: 'Amount',
		render: b => b?.amount ?? '',
	},
	{
		label: 'Payment Mode',
		render: b => b?.paymentMode || '',
	},
	{
		label: 'Payment Ref No',
		render: b => b?.paymentRef || '',
	},
	{
		label: 'Payment Date',
		render: b => (b?.paymentDate ? new Date(b.paymentDate).toLocaleDateString('en-IN') : ''),
	},
	{
		label: 'Status',
		render: b => b?.status || '',
	},
]
